import { render, staticRenderFns } from "./SolicitacoesAditivosDash.vue?vue&type=template&id=989ce8ec"
import script from "./SolicitacoesAditivosDash.vue?vue&type=script&lang=js"
export * from "./SolicitacoesAditivosDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports